import { Div } from "@tblabs/truffle";
import { appendable } from "@tblabs/truffle/Core/appendable";


export class Row extends Div
{
    constructor(...components: appendable[])
    {
        super("row");

        this.Append(
            ...components
        )
    }
}
